import { RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { WebflowLoginFlowControllerPage } from './webflow-login-flow-controller.page';

const routes: Routes = [
  {
    path: '',
    component: WebflowLoginFlowControllerPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WebflowLoginFlowControllerPageRoutingModule {}
